import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/korvue': {
    width: 446,
    height: 512,
    paths: [
      {
        d: 'M386.5 34c32.7 0 59.5 26.8 59.6 59.5v327c0 32.7-26.5 59.5-59.5 59.5h-327.1c-32.7 0-59.5-26.8-59.5-59.4v-327.1c0-32.7 26.8-59.5 59.5-59.5h327zM87.1 120.8v132h187.5l81.2-132h-110.9l-61.8 116v-116h-96zM248.9 392.9h118.4l-88.6-130.8h-191.5v130.8h96v-113.6z'
      }
    ]
  }
})
